export default __webpack_public_path__ + "static/media/NotoSansTC-Bold.ad1bddad.otf";